import { useState } from "react";
import Categories from "../Processes/conversations/utils/categories.json";
import { downloadFileHandler as downloadFile } from "~/utils/fileUtils";
import { useSelector } from "react-redux";

const useShareholderAttachments = (
  files,
  setFiles,
  regData,
  shareholderType,
) => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const { role } = useSelector((state) => state.login);

  const fileSupported = [
    "xls",
    "csv",
    "xml",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "txt",
    "doc",
    "docx",
    "xlsx",
  ];

  const uploadFileHandler = (file) => {
    setFiles((prevFiles) => [...prevFiles, ...file]);
  };

  const getShareholder = () => {
    const name =
      shareholderType === "Individual"
        ? `${regData?.name}${regData?.last_name ? " " + regData?.last_name : ""}`
        : `${regData?.legal_name}`;
    return { name };
  };

  const getCategoryAndSubcategoryNames = (categoryCode, subCategoryCode) => {
    const category = Categories.find((cat) => cat.code === categoryCode);
    const subCategory = category?.subCategory?.find(
      (sub) => sub.code === subCategoryCode,
    );

    return {
      categoryName: category?.name || categoryCode,
      subCategoryName: subCategory?.name || subCategoryCode,
    };
  };

  const downloadFileHandler = async (file) => {
    await downloadFile(
      { blob_url: file.objectURL, name: file.fileName },
      "documents",
    );
  };

  const handleDelete = (rowData) => {
    const updatedFiles = files.filter(
      (obj) => JSON.stringify(obj) !== JSON.stringify(rowData),
    );
    setFiles(updatedFiles);
  };

  return {
    showUploadModal,
    setShowUploadModal,
    fileSupported,
    uploadFileHandler,
    getShareholder,
    getCategoryAndSubcategoryNames,
    downloadFileHandler,
    handleDelete,
    role,
  };
};

export default useShareholderAttachments;
